// extracted by mini-css-extract-plugin
module.exports = {"brandDescription":"Brand_brandDescription__bIRe1","brandContent":"Brand_brandContent__DbdTK","qr":"Brand_qr__3e6j0","brandSocial":"Brand_brandSocial__1vlKZ"};